export async function getDeviceInfo() {
  const devices = await navigator.mediaDevices.enumerateDevices()

  return {
    audioInputDevices: devices.filter((device) => device.kind === "audioinput"),
    videoInputDevices: devices.filter((device) => device.kind === "videoinput"),
    audioOutputDevices: devices.filter(
      (device) => device.kind === "audiooutput"
    ),
    hasAudioInputDevices: devices.some(
      (device) => device.kind === "audioinput"
    ),
    hasVideoInputDevices: devices.some(
      (device) => device.kind === "videoinput"
    ),
  }
}

// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export async function isPermissionDenied(name: "camera" | "microphone") {
  const permissionName = name as PermissionName // workaround for https://github.com/microsoft/TypeScript/issues/33923

  if (navigator.permissions) {
    try {
      const result = await navigator.permissions.query({ name: permissionName })
      return result.state === "denied"
    } catch (e) {
      console.error(e, {
        route: "Diagnosis::utils::isPermissionDenied"
      })
      return false
    }
  } else {
    return false
  }
}

// True when both camera and microphone are already allowed (Permissions API).
// If the API is missing or the query fails, false so the Diagnosis flow can run.
export async function hasBothMediaPermissionsGranted(): Promise<boolean> {
  if (!navigator.permissions) {
    return false
  }
  try {
    const [camera, microphone] = await Promise.all([
      navigator.permissions.query({ name: "camera" as PermissionName }),
      navigator.permissions.query({ name: "microphone" as PermissionName }),
    ])
    return camera.state === "granted" && microphone.state === "granted"
  } catch (e) {
    console.error(e, {
      route: "Diagnosis::utils::hasBothMediaPermissionsGranted",
    })
    return false
  }
}
